import React, { useState } from "react";
import { FaWhatsapp, FaFacebook, FaTwitter } from "react-icons/fa";
import { toast, Slide } from "react-toastify";
import CryptoJS from "crypto-js";
import { utils } from "../common/utils";

const ReferAFriend = ({ user, handleToggle }) => {
  const [showShareIcons, setShowShareIcons] = useState(false);
  const SECRET_KEY = process.env.REACT_APP_your_secret_key;


  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };
  

  const generateReferralLink = () => {
    const baseUrl = window.location.origin; // Get the base URL
    const encryptedData = encryptData({
      referralCode: user?.referralCode,
      uid: user?.id,
    });
    return `${baseUrl}/sign-up?ref=${encodeURIComponent(encryptedData)}`;
  };

  const handleShare = (platform) => {
    const referralLink = generateReferralLink();
    let shareUrl = "";

    switch (platform) {
      case "whatsapp":
        // Open WhatsApp share dialog to let user choose contact
        shareUrl = `https://wa.me/?text=${encodeURIComponent(referralLink)}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(referralLink)}`;
        break;
      default:
        toast.error("Invalid platform selected!", {
          transition: Slide,
          closeButton: true,
          autoClose: 2000,
        });
        return;
    }

    window.open(shareUrl, "_blank");
  };

  const handleCopyLink = () => {
    const referralLink = generateReferralLink();
    navigator.clipboard.writeText(referralLink);
    toast.success("Referral link copied to clipboard!", {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: "top-right",
    });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      style={{ backdropFilter: "blur(5px)" }}
    >
      <div className="bg-white rounded-xl shadow-lg p-6 max-w-md w-full mx-4 sm:mx-auto">
        {/* Title */}
        <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4 text-center">
          Refer a Friend
        </h2>

        {/* Incentive */}
        <p className="text-sm sm:text-base text-center text-green-600 font-semibold mb-4">
          Earn up to ₹{utils?.referralRewardAmount || 50} for each successful referral!
        </p>

        {/* Referral Link */}
        <div className="mb-6">
          <p className="text-sm sm:text-base text-gray-600 mb-2 text-center">
            Share your referral link:
          </p>
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={generateReferralLink()}
              readOnly
              className="flex-grow border rounded-lg px-3 sm:px-4 py-2 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
            <button
              onClick={handleCopyLink}
              className="bg-blue-600 text-white px-3 sm:px-4 py-1 sm:py-2 rounded-lg hover:bg-blue-500 transition text-xs sm:text-sm"
            >
              Copy
            </button>
          </div>
        </div>

        {/* Social Media Sharing */}
        <div>
          <p className="text-sm sm:text-base text-gray-600 mb-2 text-center">
            Share via Social Media:
          </p>
          <div className="flex justify-center gap-6 mt-2">
            <button
              onClick={() => handleShare("whatsapp")}
              className="text-green-500 hover:text-green-600"
            >
              <FaWhatsapp size={28} />
            </button>
            <button
              onClick={() => handleShare("facebook")}
              className="text-blue-500 hover:text-blue-600"
            >
              <FaFacebook size={28} />
            </button>
            <button
              onClick={() => handleShare("twitter")}
              className="text-blue-400 hover:text-blue-500"
            >
              <FaTwitter size={28} />
            </button>
          </div>
        </div>

        {/* Close Button */}
        <button
          onClick={handleToggle}
          className="mt-6 bg-red-500 text-white px-4 py-2 rounded-lg w-full hover:bg-red-600 transition"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ReferAFriend;
